<circ-people-select [data]="data"
      textField="displayName"
      valueField="displayName"
      [(value)]="value"
      (valueChange)="internalValueChange($event)"
      (filterChange)="this.filterChange.emit($event)"
      (open)="open()"
      (close)="close()"
      (focus)="focus()"
      (blur)="blur()"
      [disabled]="disabled"
      [(loading)]="loading"
      [noDataText]="noDataText"
      [placeholder]="placeholder"
      [maxPeople]="maxPeople"
    >
</circ-people-select>
